import { Sheet } from 'react-modal-sheet';
import styled from 'styled-components';
import WaringIcon from '/img/waring-icon.png';
import { CommonButton } from '../common/CommonButton';
import { modalStore } from '../../store/modalStore';
import ModalTopBg from '/img/modal/modal-top-short.png';
import { goToPFGT } from '../../utils';

export const EndDateModal = () => {
  const { hideIsVisibleEndDate, isVisibleEndDate } = modalStore();

  return (
    <Sheet
      isOpen={isVisibleEndDate}
      onClose={hideIsVisibleEndDate}
      tweenConfig={{ ease: 'easeOut', duration: 0.2 }}
      draggable={true}
      detent={'content-height'}
    >
      <Backdrop onTap={() => {}} />
      <Sheet.Container style={{ backgroundColor: 'transparent' }}>
        <Container>
          <TitleContainer></TitleContainer>
          <Content>
            <AgreeText>
              개인정보 3자 제공 동의 기간이 종료되었습니다.
              <br />
              기간 내 정보 동의를 하지 못하신 참가자께서는
              <br />
              PFGT로 직접 문의를 부탁드립니다.
            </AgreeText>

            <WaringTextContainer>
              <img src={WaringIcon} />
              <WaringText>개인정보 미동의 시 토너먼트에 참가할 수 없습니다.</WaringText>
            </WaringTextContainer>

            <BtnContainer>
              <CommonButton theme="dark" text="닫기" click={hideIsVisibleEndDate} />
              <CommonButton
                text="PFGT 바로 가기"
                click={() => {
                  hideIsVisibleEndDate();
                  goToPFGT();
                }}
              />
            </BtnContainer>
          </Content>
        </Container>
      </Sheet.Container>
    </Sheet>
  );
};

const TitleContainer = styled.div`
  height: 35px;
  background-image: url(${ModalTopBg});
  background-size: cover;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;

const BtnContainer = styled.div`
  display: flex;
  align-items: center;

  div:first-child button {
    border-radius: 0;
  }

  div:last-child button {
    border-radius: 0;
  }
`;

const Backdrop = styled(Sheet.Backdrop)`
  background-color: rgb(0, 0, 0, 0.5) !important;
`;

const Container = styled.div``;

const Content = styled.div`
  background: #302e2d;
  padding-bottom: 0px;
`;

const AgreeText = styled.p`
  color: #eee;
  text-align: center;
  font-size: 14px;

  line-height: 20px; /* 142.857% */
  letter-spacing: -0.56px;
`;

const WaringTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  margin-top: 14px;

  img {
    margin-right: 3px;
  }
`;

const WaringText = styled.h4`
  color: #f86855;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: -0.52px;
`;
